import featuredproducts from './featured-products.css'
import {FaShoppingBasket} from 'react-icons/fa'
import {FaIdBadge} from 'react-icons/fa'
import freshVegi from '../assets/freshVegi.png'   
import mixedFruits from '../assets/mixedFruits.png' 
import fruits from '../assets/fruits.png' 
import apple from '../assets/apple-p.PNG'
import avocado from '../assets/avocado.jpg' 
import banana from '../assets/banana.jpg'  
import orange from '../assets/orange.png'  
import strawberies from '../assets/strawberies.PNG'   
import promaganate from '../assets/promaganate.jpg' 
import pineapple from '../assets/pineapple.jpg' 
import watermelon from '../assets/watermelon.PNG'


function FeaturedProducts(){
  const featuredproducts = [{name:'Apple', productpix:apple,weight:1+'kg',price:'$'+10},
                            {name:'Bannana', productpix:banana,weight:1.5+'kg',price:'$'+12},
                            {name:'Strawberies', productpix:strawberies,weight:5+'kg',price:'$'+4.5},
                            {name:'Avocado Peer', productpix:avocado,weight:1+'kg',price:'$'+10},
                            {name:'Orange', productpix:orange,weight:2+'kg',price:'$'+16},
                            {name:'Promaganate', productpix:promaganate,weight:1.5+'kg',price:'$'+12},
                            {name:'Pineapple', productpix:pineapple,weight:5+'kg',price:'$'+2},
                            {name:'Watermelon', productpix:watermelon,weight:2+'kg',price:'$'+16}
                           ]
return (
    <>
    <div className='featured-products'>
        <div>
        <div>Featured Products</div>
        </div>
        {featuredproducts.map((product,index)=>
        <div className='featured-products__items'>
         <div className='featured-products__items-imgwrap'>
          <img src = {product.productpix} lazyloading = 'true'  className='featured-products__items-img' key="{product.productpix}" />
         </div>
         <div className='featured-products__name-price__wraper'>
            <div className='featured-products__name' key="{product.name}">{product.name}</div>
            <div className='featured-products__price' key="{product.price}">{product.price}</div>
         </div>
         <div className='featured-products__weight-buy__wraper'>
         <div className='featured-products__weight' key="{product.weight}">{product.weight}</div>
         <div className='featured-products__buy'><button className='featured-products__buy-btn'>Buy</button></div>
         </div>
        </div>
         )}
    </div>
 
    </>
)
}

export default FeaturedProducts;